/**
 * 主应用 api
 */

import { isCustomerSaas } from '@/utils/globalConfig';

const infrastructure = {
  // 获取密钥
  passwordPublicKey: isCustomerSaas() ? '/client-bff/password/key' : '/infrastructure-certificate/password/key',
  // // 登录接口-用户名
  // loginGyl: '/infrastructure-certificate/account/login/pwd',
  // // 登出接口
  // loginOut: '/infrastructure-certificate/account/logout',
  // // 获取验证码 客端
  // sendVerifyCode: 'infrastructure-certificate/account/login/sendVerifyCode',
  // // 获取验证码 商端
  // merchantSendVerifyCode: 'infrastructure-certificate/merchant/login/sendVerifyCode',
  // // 验证码登录-客端
  // crmSms: '/infrastructure-certificate/account/login/sms',
  // // 验证码登录-商端
  // merchantCrmSms: '/infrastructure-certificate/merchant/v2/login/sms',
  // // 自营获取验证码
  // gylSendVerifyCode: '/infrastructure-certificate/login/phone/sendVerifyCode',
  // // 自营验证码
  // gylSms: '/infrastructure-certificate/login/phone/sms',
  // 飞书授权登录
  flyingBookLogin: '/infrastructure-certificate/account/login/feishu',
  // 钉钉授权登录，直接返回token信息
  dingtalkLogin: '/infrastructure-certificate/account/login/dingtalk',
  // 获取mqtt的订阅主题
  getMqtt: '/infrastructure-message/message/account/generateMqttTopic',
  // 获取消息数量
  getMsgCount: '/infrastructure-message/message/stationLetter/unread/count',
  // 切换用户状态
  switchState: '/operation-system/operator/state/switch',
  // 运营人员查询自身状态
  querySelfState: '/operation-system/operator/state/querySelf',
  // 菜单列表
  // menuList: '/infrastructure-authority/user/authority/resources',
  menuList: '/merchant-authority/v4/merchant/employee/authorityInfo',
  // 按钮权限
  // buttonPermissions: '/infrastructure-authority/v1/account/resource/list',
  buttonPermissions: isCustomerSaas() ? '/client-bff/v1/account/resource/list' : '/infrastructure-authority/v1/account/resource/list',
  // 公共菜单
  // baseMenuList: '/infrastructure-authority/v1/account/menu/list',
  baseMenuList: isCustomerSaas() ? '/client-bff/v1/account/menu/list' : '/infrastructure-authority/v1/account/menu/list',
  // 登录后查询用户信息
  // loginAccount: '/infrastructure-authority/v1/login/account',
  loginAccount: isCustomerSaas() ? '/client-bff/v1/login/account' : '/infrastructure-authority/v1/login/account',
  // 单个消息详情
  queryOne: '/infrastructure-message/message/stationLetter/queryOne',
  // 消息盒子-top5
  listTopFive: '/infrastructure-message/message/stationLetter/listTopFive',
  /// 代办列表
  todoTasks: '/infrastructure-workflow/v1/process/todoTasks',
  // 消息盒子-消息按分类分组统计数量
  listStationLetterCountByType: '/infrastructure-message/message/stationLetter/listStationLetterCountByType',
  // 批量标为已读
  batchMarkRead: '/infrastructure-message/message/stationLetter/batchMarkRead',
  // 租户列表
  // tenantList: 'infrastructure-authority/v1/account/tenant',
  tenantList: isCustomerSaas() ? 'client-bff/v1/account/tenant' : 'infrastructure-authority/v1/account/tenant',
  // 切换租户
  switchTenant: 'infrastructure-certificate/cert/identity/switch',
  // 创建服务单总结
  businessInsert: '/call-center/call/business/insert',
  // 服务总结信息查询
  summaryQuery: '/call-center/call/summary/query',
  // 服务总结-处理进度选项
  summaryConfig: '/call-center/call/summary/config',
  // 服务总结-保存
  summarySave: '/call-center/call/summary/save',
  // 呼叫中心——获取当前登录人的坐席信息
  agentInfo: '/call-center/call/agent/getCurrentAgent',
  // 修改密码
  modifyPassword: '/infrastructure-certificate/v1/modify/password',
  // 重置密码
  resetPassword: '/infrastructure-certificate/forget/password/phone/modify/pwd',
  // 重置密码发送验证码
  pwdSendVerifyCode: '/infrastructure-certificate/forget/password/sendVerifyCode',
  // 重置密码验证收集
  verifyPhone: '/infrastructure-certificate/forget/password/verify/mobilePhone',
  // 呼叫中心——联系人卡片查询
  queryContactCard: '/call-center/call/business/queryContactCard',
  // 外呼通话发送消息
  sendCallOutMessage: '/call-center/message/sendCallOutMessage',
  // 强制修改密码发送验证码
  forcedModifySendCode: '/infrastructure-certificate/password/forcedModify/sendVerifyCode',
  // 强制修改密码
  forcedModifyPwd: '/infrastructure-certificate/password/forcedModify/pwd',
  // 获取字典
  dictionaryTableObject: '/infrastructure-integration/dictionary/object/key/get',
  // 呼叫日志
  callLogSave: '/call-center/web/call/log/save',
  // 未正常接通回铃音保存
  recordCallError: '/call-center/call/business/recordCallError',
  // 客saas登录
  managerLogin: '/infrastructure-certificate/v1/tenant/manager/account/login',
  // 获取环境
  garyEnv: '/infrastructure-certificate/login/env',
  // 新飞书审批
  routerParam: '/infrastructure-workflow/v1/process/routerParam',
  // 记录协议和政策
  agreementRecord: '/infrastructure-certificate/extend/agreement/record',

  // 雏鹰二期

  // 前端查询应用信息接口
  getAllUiInfo: '/infrastructure-license/internet/v1/license/app/info',
  // 域账号登录
  login: '/infrastructure-certificate/internet/user/login/domain',
  // 验证码登录
  userLoginSms: '/infrastructure-certificate/internet/user/login/sms',
  // 验证码登录 加密
  // userLoginSmsV2: '/infrastructure-certificate/v2/internet/user/login/sms',
  userLoginSmsV2: isCustomerSaas() ? '/client-bff/v2/internet/user/login/sms' : '/infrastructure-certificate/v2/internet/user/login/sms',
  // 获取验证码
  // internetSendVerifyCode: '/infrastructure-certificate/internet/user/login/sendVerifyCode',
  internetSendVerifyCode: isCustomerSaas() ? '/client-bff/internet/user/login/sendVerifyCode' : '/infrastructure-certificate/internet/user/login/sendVerifyCode',
  // 三方登录（SaaS 私有化）
  thirdLogin: '/client-bff/web/open/sso/third/login',
  // 三方登录 ticket 换取 token（SaaS 私有化）
  ssoExchange: '/client-bff/web/open/sso/exchange',
  // 账号密码登录
  internetLoginPwd: '/infrastructure-certificate/internet/user/login/pwd',
  // 获取当前登录账号的激活状态
  queryAccountStatus: '/infrastructure-certificate/v1/query/accountStatus',

  // 初始化账号密码
  accountAndPassword: '/infrastructure-certificate/v1/modify/accountAndPassword',
  // code换token
  userLoginCode: '/infrastructure-certificate/intranet/user/login/code',

  // 获取装修页面
  // getUiApply: '/infrastructure-authority/v1/object/700240/layout/1/apply',
  getUiApply: '/client-bff/v1/tenant/theme/custom',

  userLoginTps: '/infrastructure-certificate/internet/user/login/tps', // 三方系统登录

  accountRoles: '/infrastructure-authority/intranet/v2/tenant/query/login/account/roles',

  // 查询租户管理员
  accountAdminQuery: '/infrastructure-authority/intranet/v2/tenant/account/admin/query',

  // 租户下账号注销接口
  accountCancel: '/infrastructure-certificate/intranet/v2/tenant/account/cancel',
  // 租户注销接口
  tenantCancel: '/infrastructure-certificate/intranet/v2/tenant/cancel',
  // 保存用户签署的协议
  forceUserToAgree: '/infrastructure-license/intranet/v1/user/agreement/policy/save',
  // 保存用户签署的协议
  getAgreementList: '/infrastructure-license/intranet/v1/user/agreement/policy/check/version',
};

export default {
  ...infrastructure,
};
